import {
  Component,
} from "react";
import {
  Button,
  Modal,
} from "react-bootstrap";

export default class AntragStatuswechselValidierungPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, errorMessage } = this.props;

    return (

      <Modal show onHide={onClose}>
        <Modal.Header>
          Statuswechsel nicht möglich
        </Modal.Header>
        <Modal.Body>
          {errorMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={this.onConfirm}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  onConfirm = () => {
    this.props.onClose();
  };
}

